import { Section } from '@/components/shared';
import { Box, Button, Container, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { steps } from '../constants';
import type { ISectionItemWithImage } from '../types';

const Step: React.FC<ISectionItemWithImage> = (props): JSX.Element => {
  const { content, id, image, srcSet, title } = props;
  return (
    <>
      <Box maxW={{ base: 'full', sm: 300, md: 600 }}>
        <Image alt={id} src={image} srcSet={srcSet} />
      </Box>
      <Box maxWidth={500} textAlign={{ base: 'center', md: 'left' }}>
        <Heading
          fontSize={{ base: 'h2.base', md: 'h2.md' }}
          fontWeight="normal"
          mb={{ base: '10px', md: '16px' }}
        >
          {title}
        </Heading>
        <Text fontSize={{ base: 'medium', md: 'large' }}>{content}</Text>
      </Box>
    </>
  );
};

export const Steps = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Section
      headingProps={{ mt: { base: 12, md: '120px' } }}
      id="how-it-works"
      title={t('LANDING.STEPS.SECTION_TITLE')}
    >
      <Container maxW="container.xl" px={{ base: 0, md: 4 }} textAlign="center">
        {steps.map(({ content, title, ...rest }, i) => (
          <Flex
            alignItems="center"
            direction={{ base: 'column', md: i % 2 === 0 ? 'row-reverse' : 'row' }}
            gap={4}
            justifyContent="space-between"
            key={rest.id}
            mb={12}
          >
            <Step content={t(content)} title={t(title)} {...rest} />
          </Flex>
        ))}
        <Button as="a" href="/quote/user" variant="mbePrimary">
          {t('LANDING.STEPS.SECTION_CTA')}
        </Button>
      </Container>
    </Section>
  );
};
